'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var type = require('../type.js');
var coreRenderer = require('@tempi/core-renderer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const BubbleItem = ({ item, position }) => {
  var _a, _b, _c;
  if (!item)
    return null;
  const getPropsLink = (href) => {
    if (!href)
      return;
    const phoneNumber = href.replace(/-|\.|\s/g, "");
    if (coreRenderer.PATTERN_VALIDATION.phone.test(phoneNumber))
      return {
        href: `tel:${phoneNumber}`,
        target: "_self"
      };
    return {
      href,
      target: "_blank"
    };
  };
  return /* @__PURE__ */ jsxRuntime.jsxs(Wrapper, {
    position,
    children: [
      (item == null ? void 0 : item.icon) && /* @__PURE__ */ jsxRuntime.jsx("a", __spreadProps(__spreadValues({}, getPropsLink(item.href)), {
        rel: "noreferrer",
        children: /* @__PURE__ */ jsxRuntime.jsx("img", __spreadValues({
          src: (_a = item.icon) == null ? void 0 : _a.src,
          alt: item.title,
          height: item.size
        }, ((_b = item.icon) == null ? void 0 : _b.src) && {
          srcSet: coreRenderer.buildSrcsetDPR((_c = item.icon) == null ? void 0 : _c.src, item.size)
        }))
      })),
      /* @__PURE__ */ jsxRuntime.jsx(Label, {
        children: item == null ? void 0 : item.title
      })
    ]
  });
};
const getFlexDirection = (position) => {
  switch (position) {
    case type.ContactBubblePosition.BOTTOM_LEFT:
    case type.ContactBubblePosition.CENTER_LEFT:
      return "row";
    case type.ContactBubblePosition.BOTTOM_RIGHT:
    case type.ContactBubblePosition.CENTER_RIGHT:
      return "row-reverse";
    default:
      return "row";
  }
};
const Wrapper = styled__default["default"].div(
  ({ position }) => `
a:hover ~ p {
  display: block;
}

display: flex;
align-items: center;
flex-direction: row-reverse;
gap: 0.8em;
flex-direction: ${getFlexDirection(position)};
`
);
const Label = styled__default["default"].p`
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  position: relative;
  display: none;
  padding: 6px 10px;
`;

exports.BubbleItem = BubbleItem;
